import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {__usuarios_endpoints} from "@components/usuario/endpoints/__usuarios_endpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export function useNotificacao() {
    const {Get} = useApi()

    const getNotificacoes = (excluirLidos: boolean, pagination: IPagination) => {
        return Get(__usuarios_endpoints.GetMinhasNotificacoes({excluirLidos}, pagination))
    }

    return {getNotificacoes}
}